/*eslint-disable*/
import { createRouter, createWebHistory } from "vue-router"; 
 import store from "../store";

import AbonnementExpirerView from "../views/AbonnementExpirerView.vue";

import WaitersView from "../views/Waiter/WaitersView.vue";
import AddwaiterView from "../views/Waiter/AddwaiterView.vue";
import EditWaiterView from "../views/Waiter/EditWaiterView.vue";

import AdminsView from "../views/Admin/AdminsView.vue";
import AddAdminView from "../views/Admin/AddAdminView.vue";
import EditAdminView from "../views/Admin/EditAdminView.vue";

import ManagersView from "../views/Manager/ManagersView.vue";
import AddmanagerView from "../views/Manager/AddmanagerView.vue";
import EditManagerView from "../views/Manager/EditManagerView.vue";
import AffecteRestaurantsView from "../views/Manager/AffecteRestaurantsView.vue";
import SubscriptionsCsiCodes from "../views/Manager/SubscriptionsCsiCodes.vue";
import SubscriptionsPaid from "../views/Manager/SubscriptionsPaid.vue";

import RenouvelerAbonnementView from "../views/Restaurants/RenouvelerAbonnementView.vue";
import ResilierAbonnementView from "../views/Restaurants/ResilierAbonnementView.vue";
import AddrestaurantView from "../views/Restaurants/AddrestaurantView.vue";
import RestaurantView from "../views/Restaurants/RestaurantView.vue";
import EditRestaurantView from "../views/Restaurants/EditRestaurantView.vue";
import DetailsRestaurant from "../views/Restaurants/DetailsRestaurant.vue";

import ProfileView from "../views/Profile/ProfileView.vue";
import EditprofileView from "../views/Profile/EditprofileView.vue";
import EditpasswordView from "../views/Profile/EditpasswordView.vue";
import LoginView from "../views/LoginView.vue";
import ResetPassword from "../views/ResetPassword.vue";
import PasswordForgotten from "../views/PasswordForgotten.vue";
 
import RegisterView from "../views/RegisterView.vue";
import PageNotFound from "../views/PageNotFoundView.vue";

import Parametrages from "../views/Parametrages/index.vue";

//by ayoub
import Tickets from "../views/tickets/TicketIndex.vue";
import detailsTicket from "../views/tickets/DetailsTicket.vue";
import detailsTickets from "../views/tickets/DetailsTickets.vue";

import UploadXmlFiles from "../views/Files/UploadXmlFiles.vue";
import AssignUserToStore from "../views/UserStoreAssignment/AssignUserToStore.vue";


//import TicketsBaliseName from "../views/ticketsByBaliseName/index.vue";
//import OperationdetailsTicket from "../views/ticketsByBaliseName/details_ticket.vue";

import DashboardTop from "../views/dashboard/DashboardTop.vue";
import Dashboard from "../views/dashboard/DashboardIndex.vue";
import DashboardCouvert from "../views/dashboard/DashboardCouvert.vue"; // flash info
import DashboardCA from "../views/dashboard/DashboardCA.vue";
import DashboardRegulations from "../views/dashboard/DashboardRegulations.vue";
import StatisticVendeurs from "../views/dashboard/StatisticVendeurs.vue";


import ChiffreAffaires from "../views/dashboard/ChiffreAffaires.vue";

import Vendeurs from "../views/vendeurs/VendeursIndex.vue";
import Pointeuses from "../views/vendeurs/PointeusesIndex.vue";
 import StatisticRemise from "../views/Statistique/StatisticRemise.vue";
import StatisticVentesParVendeur from "../views/Statistique/StatisticVentesParVendeur.vue";
import RevenuStatistic from "../views/Statistique/RevenuStatistic.vue";

import Reports from "../views/reports/ReportIndex.vue";
import ReportsJournalierTVA from "../views/reports/ReportsJournalierTVA.vue";
import ReportsJournalierPayement from "../views/reports/ReportsJournalierPayement.vue";


/***Abonner */
import AbonnerRestaurant from "../views/Abonner/AbonnerRestaurant.vue";
import payementSuccess from "../views/Abonner/payementSuccess.vue";
import payementCancled from "../views/Abonner/payementCancled.vue";
import RenouvelerAbonnement from "../views/Abonner/RenouvelerAbonnement.vue";
import DetailsRestaurantManager from "../views/Abonner/DetailsRestaurant.vue";
import ModifierRestaurantManager from "../views/Abonner/EditRestaurantView.vue";
import ListRestaurantsView from "../views/Abonner/RestaurantView.vue";

import AbonnementsView from "../views/Abonnements/AbonnementsView.vue";
import CodecsisView from "../views/Codecsis/CodecsisView.vue";

import ComptesView from "../views/Comptes/ComptesView.vue";
import DebiteursView from "../views/Comptes/DebiteursView.vue";
import TicketsCompteView from "../views/Comptes/TicketsCompteView.vue";
import TicketsDebiteurView from "../views/Comptes/TicketsDebiteurView.vue";


const BASE_ROUTE = process.env.VUE_APP_BASE_ROUTE || "/";

const routes = [
 
  /*** routes by ayb */
  // {
  //   path: "/",
  //   name: "dashboard",
  //   component: Dashboard,
  //   meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  // },
  {
    path: "/",
    name: "dashboard",
    component: DashboardCouvert,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/top",
    name: "top",
    component: DashboardTop,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  //
  {
    path: "/chiffre-affaires",
    name: "chiffre-affaires",
    component: DashboardCA,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/regulations",
    name: "regulations",
    component: DashboardRegulations,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/statistiques-vendeurs",
    name: "statistiques-vendeurs",
    component: StatisticVendeurs,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/global-chiffre-affaires",
    name: "global-chiffre-affaires",
    component: ChiffreAffaires,
    meta: { isComponentDates: false, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/vendeurs",
    name: "vendeurs",
    component: Vendeurs,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/pointeuse",
    name: "pointeuse",
    component: Pointeuses,
    meta: { isComponentDates: false, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
 
  {
    path: "/statistiques-remises",
    name: "statistiques-remises",
    component: StatisticRemise,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/statistiques-par-vendeurs",
    name: "statistiques-par-vendeurs",
    component: StatisticVentesParVendeur,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },

  {
    path: "/revenu-par-statistiques",
    name: "revenu-par-statistiques",
    component: RevenuStatistic,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/tickets",
    name: "tickets",
    component: Tickets,
    meta: { isComponentDates: false, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/detailsticket/:id",
    name: "detailsticket",
    component: detailsTicket,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/detailstickets",
    name: "detailstickets",
    component: detailsTickets,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
 
  {
    path: "/reports",
    name: "reports",
    component: Reports,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/reports-journalier-tva",
    name: "reports-journalier-tva",
    component: ReportsJournalierTVA,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/reports-journalier-paiements",
    name: "reports-journalier-paiements",
    component: ReportsJournalierPayement,
    meta: { isComponentDates: true, requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  /****end routes by ayb */
 
 
  {
    path: "/waiters",
    name: "waiters",
    component: WaitersView,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/addwaiter",
    name: "addwaiter",
    component: AddwaiterView,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/managers",
    name: "managers",
    component: ManagersView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/addmanager",
    name: "addmanager",
    component: AddmanagerView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/admins",
    name: "admins",
    component: AdminsView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/addadmin",
    name: "addadmin",
    component: AddAdminView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/restaurants",
    name: "restaurants",
    component: RestaurantView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/details-restaurant/:id",
    name: "details-restaurant",
    component: DetailsRestaurant,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/addrestaurant",
    name: "addrestaurant",
    component: AddrestaurantView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/creation-restaurant",
    name: "creation-restaurant",
    component: AbonnerRestaurant,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: [] },
  },
  {
    path: "/renouveler-abonnement/:id",
    name: "renouveler-abonnement",
    component: RenouvelerAbonnementView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

  {
    path: "/resilier-abonnement/:id",
    name: "resilier-abonnement",
    component: ResilierAbonnementView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

  {
    path: "/modifier-restaurant/:id",
    name: "modifier-restaurant",
    component: EditRestaurantView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfileView,
    meta: { requiresAuth: true, withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/editprofile",
    name: "editprofile",
    component: EditprofileView,
    meta: { requiresAuth: true, withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/xml-files/upload",
    name: "upload-multi-xml-files",
    component: UploadXmlFiles,
    meta: { requiresAuth: true, withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/assign-user-to-store",
    name: "assign-user-to-store",
    component: AssignUserToStore,
    meta: { requiresAuth: false, withComponents: ['navbar', 'footer', 'sidebar', 'AssignUserToStore'] },
  },
  
  {
    path: "/editpassword",
    name: "editpassword",
    component: EditpasswordView,
    meta: { requiresAuth: true, withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/editmanager",
    name: "editmanager",
    component: EditManagerView,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/affecte-restaurants",
    name: "affecte-restaurants",
    component: AffecteRestaurantsView,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/subscriptions-csicodes",
    name: "subscriptions-csicodes",
    component: SubscriptionsCsiCodes,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/subscriptions-paid",
    name: "subscriptions-paid",
    component: SubscriptionsPaid,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/editadmin",
    name: "editadmin",
    component: EditAdminView,
    meta: { requiresAuth: true, roles: ['super-admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/editwaiter",
    name: "editwaiter",
    component: EditWaiterView,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

  {
    path: "/abonnement-expirer",
    name: "abonnement-expirer",
    component: AbonnementExpirerView,
    meta: { requiresAuth: true, roles: ['super-admin', 'admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

 
  {
    path: "/parametrages",
    name: "parametrages",
    component: Parametrages,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/payement-success/:token",
    name: "payement-success",
    component: payementSuccess,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: [] },
  },
  {
    path: "/payement-cancled/:token",
    name: "payement-cancled",
    component: payementCancled,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: [] },
  },
  {
    path: "/renouveler",
    name: "renouveler",
    component: RenouvelerAbonnement,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { guest: true, roles: [], withComponents: [] },
  },
  {
    path: "/password-forgotten",
    name: "password-forgotten",
    component: PasswordForgotten,
    meta: { requiresAuth: false, guest: true, roles: [], withComponents: [] },
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: ResetPassword,
    meta: { requiresAuth: false, guest: true, roles: [], withComponents: [] },
  },
  
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: { requiresAuth: false, guest: true, roles: [], withComponents: [] },
  },
  {
    path: "/abonnements",
    name: "Abonnements",
    component: AbonnementsView,
    meta: { requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/codecsi",
    name: "Codecsi",
    component: CodecsisView,
    meta: { requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

  {
    path: "/list-restaurants",
    name: "list-restaurants",
    component: ListRestaurantsView,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/details-restaurant-manager/:id",
    name: "details-restaurant-manager",
    component: DetailsRestaurantManager,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/modifier-restaurant-manager/:id",
    name: "modifier-restaurant-manager",
    component: ModifierRestaurantManager,
    meta: { requiresAuth: true, roles: ['manager'], withComponents: ['navbar', 'footer', 'sidebar', 'WelcomeToReporting', 'AbonnementExpirerView'] },
  },
  {
    path: "/comptes",
    name: "comptes",
    component: ComptesView,
    meta: { requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },

  {
    path: "/tickets-compte/:id",
    name: "tickets-compte",
    component: TicketsCompteView,
    meta: { isComponentDates: false, requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/debiteurs",
    name: "debiteurs",
    component: DebiteursView,
    meta: { requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/debiteur-tickets/:id",
    name: "debiteur-tickets",
    component: TicketsDebiteurView,
    meta: { isComponentDates: false, requiresAuth: true, roles: ['super-admin', 'manager'], withComponents: ['navbar', 'footer', 'sidebar'] },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: PageNotFound,
    meta: { requiresAuth: true, withComponents: ['navbar', 'footer', 'sidebar'] },
  },
];

const router = createRouter({
  //base: BASE_ROUTE,
  mode: 'history',
  history: createWebHistory(),
  routes,
});


// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   if (requiresAuth && !store.getters.isRole) {
//     next('/login')
//   } else if (requiresAuth && store.getters.isRole) {
//     const requiredRoles = to.meta.roles
//     if (requiredRoles && !requiredRoles.some(role => store.getters.isRole.includes(role))) {
//       if (store.getters.isRole == 'admin' || store.getters.isRole == 'super-admin')
//         next('/restaurants')
//       else
//         next('/')
//     }
//     else {
//       if (store.getters.isRole == 'manager' && !store.getters.StateIsAbonnementActif) {
//         if (to.name == 'creation-restaurant' || to.name == 'renouveler' || to.name == 'payement-success' || to.name == 'payement-cancled') {
//           next()
//         }
//         else {
//           next('/abonnement-expirer')
//         }
//         return
//       } else {
//         next()
//       }
//     }
//   }
//   else {
//     next()
//   }
// })


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const userRole = store.getters.isRole
  if (requiresAuth && !userRole) {
    next('/login')
    return
  }
  if (requiresAuth) {
    const requiredRoles = to.meta.roles
    const isAdmin = userRole === 'admin'
    const isSuperAdmin = userRole === 'super-admin'
    const isManager = userRole === 'manager'
    if (requiredRoles && !requiredRoles.some(role => userRole.includes(role))) {
      if (isSuperAdmin) {
        next(  '/admins'  )
      } else {
        next( '/subscriptions-csicodes')
      }
       
    } else if (isManager && !store.getters.StateIsAbonnementActif) {
      const pages = ['creation-restaurant', 'list-restaurants', 'renouveler', 'payement-success', 'details-restaurant-manager', 'modifier-restaurant-manager', 'payement-cancled']
      if (pages.includes(to.name) || to.path === '/') {
        next()
      } else {
        next('/')
        // next('/abonnement-expirer')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})


// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (store.getters.isAuthenticated) {
//       next();
//       return;
//     }
//     next("/login");
//   } else {
//     next();
//   }
// });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default router;
